
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useRegionCurrency = (selectedRegion: string) => {
  return useQuery({
    queryKey: ["region-currency", selectedRegion],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("regions")
        .select("currency")
        .eq("code", selectedRegion)
        .single();
        
      if (error) throw error;
      return data?.currency || "Ksh";
    },
  });
};
